<template>
  <van-form @submit="onSubmit">
    <h3 class="card-edit-section-title section-title">
      {{ $t("box information") }}
    </h3>
    <van-field
      v-model="name"
      name="name"
      :label="$t('name')"
      :placeholder="$t('input box name')"
      :rules="[{ required: true, message: $t('box name is required') }]"
    />
    <!-- <van-field
      name="name"
      :value="name"
      :label="$t('name')"
      :placeholder="$t('input name')"
      :rules="[{ required: true, message: $t('box name is required') }]"
    /> -->
    <van-field name="uploader" :label="$t('image')">
      <template #input>
        <van-uploader v-model="uploader" :multiple="false" :max-count="1" />
      </template>
    </van-field>
    <van-field name="switch" :label="$t('is public')">
      <template #input>
        <van-switch v-model="isPublic" size="20" />
      </template>
    </van-field>
    <div style="margin: 16px; display:flex">
      <van-button
        round
        block
        type="info"
        native-type="save"
        :loading="submitting"
      >
        {{ $t("submit") }}
      </van-button>
    </div>
  </van-form>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "BoxDetailsForm",
  props: {
    box: {
      type: Object,
      required: false
    },
    classroom: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      name: "",
      submitting: false,
      isPublic: true,
      uploader: []
    };
  },
  methods: {
    ...mapActions("vokabel", ["editBoxDetails", "createNewBox"]),
    boundForm() {
      if (this.box) {
        this.name = this.box.name;
        this.isPublic = this.box.public;
        if (this.box.image) {
          this.uploader = [
            {
              url: `https://f002.backblazeb2.com/file/sprkr-user-uploads/${this.box.image}`
            }
          ];
        }
      }
    },
    onSubmit() {
      if (this.box) {
        this.submitEdit();
      } else {
        this.submitNew();
      }
    },
    setupFormData() {
      this.submitting = true;
      const { isPublic, name, uploader, classroom } = this;
      let classroomId = classroom ? classroom.id : null;
      let formData = new FormData();
      formData.append("classroom", classroomId);
      formData.append("name", name);
      formData.append("public", isPublic);
      // let formData = { name, public: isPublic, classroom: classroomId };
      if (uploader.length > 0 && uploader[0].content) {
        // formData = new FormData();
        formData.append("image_upload", uploader[0].file);
      }
      return formData;
    },
    submitEdit() {
      const { box } = this;
      let id = box.id;
      let formData = this.setupFormData();
      this.editBoxDetails({ id, formData }).then(() => {
        this.submitting = false;
        this.$emit("closeEdit");
      });
    },
    submitNew() {
      let formData = this.setupFormData();
      this.createNewBox(formData).then(() => {
        this.submitting = false;
        this.$emit("closeEdit");
      });
    }
  },
  mounted() {
    if (this.box) {
      this.boundForm();
    }
  }
};
</script>
